//@ts-ignore
import React, { useEffect, useState } from "react";
import alternativeFinanceLogo from "../../assets/images/alt-finance-logo.svg";
import farmerImage from "../../assets/images/farmer.jpg";
import familyImage from "../../assets/images/family.jpg";
import womanImage from "../../assets/images/woman.jpg";
import manImage from "../../assets/images/man.jpg";
import Icon_L from "../../assets/images/Icon_L.svg";
import BusinessTypeInfo from "../../Components/BusinessTypeInfo";
import styles from "./style.module.css";
import { setAccountOpeningStep } from "../../redux/accountOpening";
import CbnFooter from "../../Components/CbnFooter";

export default function BusinessAccount() {
  const [accountType, setAccountType] = useState(null);
  const [hidden, setHidden] = useState(true);
  const [selectName, setSelectName] = useState("Select account type");

  const toggleHidden = () => {
    setHidden(!hidden);
  };

  const selectBusiness = () => {
    setHidden(true);
    selectAccountType("Business account");
    setSelectName("Business account");
  };
  const selectCompany = () => {
    setHidden(true);
    selectAccountType("Company account");
    setSelectName("Company account");
  };

  const selectAccountType = (accountType: any) => {
    setAccountType(accountType);
  };

  const resetAccountType = () => {
    setAccountType(null);
  };
  return (
    <div>
      <div className="container-fluid row mx-0 p-0">
        <div
          className="d-none d-md-inline col-md-4 p-0 mx-0"
          style={{ height: "99vh", position: "relative" }}
        >
          <div className="logo">
            <img src={alternativeFinanceLogo} alt="alternative-finance-logo" />
          </div>
          <div
            id="carouselExampleSlidesOnly"
            className="carousel slide carousel-fade"
            data-ride="carousel"
          >
            <div className="carousel-inner" id="carousel-overlay">
              <div className="carousel-item active">
                <img src={farmerImage} className="d-block w-100" alt="farmer" />
              </div>
              <div className="carousel-item">
                <img src={familyImage} className="d-block w-100" alt="family" />
              </div>
              <div className="carousel-item">
                <img src={womanImage} className="d-block w-100" alt="women" />
              </div>
              <div className="carousel-item">
                <img src={manImage} className="d-block w-100" alt="men" />
              </div>
            </div>
          </div>
          <div className={styles.cbnFooterContainer}>
            <CbnFooter />
          </div>
        </div>

        <div className="col-md-8 p-2 px-4 pl-md-5 pr-md-5">
          <div className="row mx-auto d-flex justify-content-between d-md-none d-lg-flex">
            <div className="container mt-5 pt-5 mx-auto pl-md-4 pr-md-4">
              <h1 className="big-bold-texts text-left">
                Corporate/Business Account
              </h1>{" "}
              <div className={styles.popUp}>
                <img src={Icon_L} alt="" />
                <p>. This service is available to only registered entities</p>
              </div>
              <br />
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-home"
                  role="tabpanel"
                  aria-labelledby="pills-home-tab"
                >
                  <div className="select-group">
                    <div className=" small-label-texts text-left">
                      {" "}
                      <label htmlFor="button">Select account type</label>
                    </div>

                    <div
                      id="dropper-button"
                      className="dropper-button"
                      onClick={toggleHidden}
                    >
                      <span id="select-label">{selectName}</span>
                      <div id="arrow" className="arrow">
                        <i className="bx bx-chevron-down pl-5 faq-chevron"></i>
                      </div>
                    </div>

                    <div
                      className={`dropper ${hidden && "hidden"}`}
                      id="dropper"
                    >
                      <div onClick={selectBusiness}>
                        <input
                          type="radio"
                          id="select-swift-savings"
                          name="where"
                          value="Swift-Savings"
                          className="option"
                        />
                        <label
                          htmlFor="select-swift-savings"
                          className="select-item"
                        >
                          Business account
                          <p>Registered Business (BNS)</p>
                        </label>
                        <hr className="m-0" />
                      </div>

                      <div onClick={selectCompany}>
                        <input
                          type="radio"
                          id="select-savings"
                          name="where"
                          value="Savings"
                          className="option"
                        />
                        <label htmlFor="select-savings" className="select-item">
                          Company Account
                          <p>Limited companies (RCs)</p>
                        </label>
                        <hr className="m-0" />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="pills-profile"
                  role="tabpanel"
                  aria-labelledby="pills-profile-tab"
                ></div>

                {accountType ? (
                  <BusinessTypeInfo accountType={accountType} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
